/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface DeleteEntry$Params {
  formId: string;
  formRiskEntryId: string;
}

export function deleteEntry(
  http: HttpClient,
  rootUrl: string,
  params: DeleteEntry$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteEntry.PATH, 'delete');
  if (params) {
    rb.path('formId', params.formId, {});
    rb.path('formRiskEntryId', params.formRiskEntryId, {});
  }

  return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteEntry.PATH = '/auditing/forms/{formId}/risk-entry/{formRiskEntryId}';
